import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { apiResponse } from '../models/apiResponse.model';
import { addValuationDocument, buyValuationByCustomer, finishValuation, setInspectionAddress, setTransportAddress, updateDeliveryDate, updateValuationCustomer } from '../models/valuation-request';

@Injectable()
export class ApiService {
    private readonly api_base: string = environment.apiUrl;
    constructor(private readonly http: HttpClient) { }

    public getValuationIdByHash(id: number, hash: string) {
        const RequestHeaders = new HttpHeaders().set('Accept', 'application/json');
        let Params = new HttpParams()
        return this.http.get<apiResponse>(this.api_base + '/request/v1/valuation/' + id + '/hash/' + hash, { headers: RequestHeaders, params: Params });
    }

    public getValuationId(id: number) {
        const RequestHeaders = new HttpHeaders().set('Accept', 'application/json');
        let Params = new HttpParams()
        return this.http.get<apiResponse>(this.api_base + '/request/v1/valuation/' + id, { headers: RequestHeaders, params: Params });
    }

    public getDateRange(date: string, days: number, weekendDays?: string) {
        const RequestHeaders = new HttpHeaders().set('Accept', 'application/json');
        let Params = new HttpParams()
        Params = Params.append('date', date)
        Params = Params.append('days', String(days))
        if (weekendDays) Params = Params.append('weekendDays', weekendDays);
        return this.http.get<apiResponse>(this.api_base + '/api/v1/date/range', { headers: RequestHeaders, params: Params });
    }

    public buyValuationByCustomer(id: number, hash: string, params: buyValuationByCustomer) {
        const RequestHeaders = new HttpHeaders()
            .set('Accept', 'application/json')
        return this.http.put<apiResponse>(this.api_base + '/request/v1/valuation/' + id + '/buy-by-customer/' + hash, params, { headers: RequestHeaders });
    }

    public updateValuationCustomer(id: number, params: updateValuationCustomer) {
        const RequestHeaders = new HttpHeaders()
            .set('Accept', 'application/json')
        return this.http.put<apiResponse>(this.api_base + '/request/v1/valuation/' + id + '/customer', params, { headers: RequestHeaders });
    }

    public setTransportAddress(id: number, params: setTransportAddress) {
        const RequestHeaders = new HttpHeaders()
            .set('Accept', 'application/json')
        return this.http.put<apiResponse>(this.api_base + '/request/v1/valuation/' + id + '/transport-address', params, { headers: RequestHeaders });
    }

    public addValuationDocument(id: number, params: addValuationDocument) {
        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post<apiResponse>(this.api_base + '/request/v1/valuation/' + id + '/document', params, { headers: headers });
    }

    public updateDateDelivery(id: number, data: updateDeliveryDate) {
        const RequestHeaders = new HttpHeaders()
            .set('Accept', 'application/json')
        return this.http.put<apiResponse>(this.api_base + '/request/v1/valuation/' + id + '/date-delivery', data, { headers: RequestHeaders });
    }

    public finishValuation(id: number, hash: string, data: finishValuation) {
        const RequestHeaders = new HttpHeaders()
            .set('Accept', 'application/json')
        return this.http.put<apiResponse>(this.api_base + '/request/v1/valuation/' + id + '/finish-by-customer/' + hash, data, { headers: RequestHeaders });
    }

    public setInspectionAddress(id: number, data: setInspectionAddress) {
        const RequestHeaders = new HttpHeaders()
            .set('Accept', 'application/json')
        return this.http.put<apiResponse>(this.api_base + '/request/v1/valuation/' + id + '/inspection-address', data, { headers: RequestHeaders });
    }
}
